import LogsPage from 'src/logs/containers/LogsPage'

export {LogsPage}
